import React from 'react';
import {imagesData} from 'data/images-data';
import './image-loader.scss';

const ImageLoader = () => {
	const images = imagesData;
	return (
		<div className={'ImageLoader'}>
			{images.map((file, index) => {
				let imgSrc = require('assets/images/' + file).default;
				return <img key={index} src={imgSrc} alt="preload" />;
			})}
		</div>
	);
};

export default ImageLoader;